/**
 *  komponenta pro štítky pro produkty
 */
import React, { Fragment, useState } from "react";
import AddEditClub from "./AddEditClub";
import ModalNotification from "../../../GlobalComponents/ModalNotification";
import Notification from "../../../Library/notification";
import { useQuery, useMutation, useApolloClient } from "@apollo/client";
import { GET_CLUBS, DELETE_CLUBS } from "../Queries/club";
import Loading from "../../../GlobalComponents/Loading";
import Error from "../../../GlobalComponents/Error";
import edit from "../../../Public/Images/edit.svg";
import NoItems from "../../../GlobalComponents/NoItems";
import Helper from "../../../Library/helper";
import translate from "../../Translations/index";
import SearchInput from "../../General/Components/SearchInput";

const Clubs = (props) => {
    const client = useApolloClient();
    //zjistime jestli ma prihlaseny administrator spravna prava
    const helper = new Helper();
    helper.checkAdminRights({ ...props, client }, ["1", "2"]);

    const [searchQuery, setSearchQuery] = useState("");
    const [listVariables, setListVariables] = useState({
        filters: {
            offset: 0,
            limit: 50,
            searchQuery: "",
            sportID: 0,
            countryID: 0,
            federationID: 0,
        },
        lang: translate.locale,
    });

    const [selectedClubs, setSelectedClubs] = useState([]);
    const [showDeleteNotifi, setShowDeleteNotifi] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [selectedClubID, setSelectedClubID] = useState("");
    const {
        loading,
        error: getError,
        data: clubListData,
        fetchMore,
        refetch,
    } = useQuery(GET_CLUBS, {
        variables: listVariables,
        fetchPolicy: "cache-and-network",
        onError(err) {
            const helper = new Helper();
            let notify = new Notification();
            notify.setNotification(!!err.message ? err.message : err.toString(), "danger");
        },
    });

    const [deleteClub, { data, loading: deleteLoading, error: deleteError }] = useMutation(DELETE_CLUBS, {
        update(cache, response) {
            let notify = new Notification();
            notify.setNotification(translate.t("SuccessFullyDeleted"));
            setShowDeleteNotifi(false);
            refetch({ filters: { ...listVariables.filters, limit: clubListData.clubs.length } });
        },
        onError(err) {
            const helper = new Helper();
            let notify = new Notification();
            notify.setNotification(!!err.message ? err.message : err.toString(), "danger");
        },
    });

    const openCloseModal = (open, clubID) => {
        setSelectedClubID(clubID);
        setShowAdd(open);
    };

    /**
     * smazání štítků
     * @param {*} deleteClubs funkce, která posílá data na server
     * @param {*} clubID ID clubu
     */

    const initiateDeleteClub = (e, clubID) => {
        var checked = e.target.checked;
        var arr = [...selectedClubs];

        if (!checked) {
            for (let i in selectedClubs) {
                if (selectedClubs[i] == clubID) {
                    arr.splice(i, 1);
                }
            }
        } else {
            arr = [clubID, ...arr];
        }

        setSelectedClubs(arr);
    };

    const delClub = (action) => {
        if (action) {
            let clubIDs = selectedClubs.join(",");

            deleteClub({
                variables: {
                    clubIDs: clubIDs,
                },
            });
        }
        setShowDeleteNotifi(false);
        //this.setState(INITIAL_STATE);
    };

    const showDelNotifi = () => {
        if (selectedClubs.length > 0) {
            setShowDeleteNotifi(true);
        } else {
            let notify = new Notification();
            notify.setNotification(translate.t("ItemNotSelected"), "danger");
        }
    };

    if (getError || deleteError) {
        var error = getError ? getError : deleteError;
        const helper = new Helper();
        error = "ERROR: " + helper.getApolloErrorText(error);
    }
    return (
        <div id="settings" className="whole-container">
            <div className="row">
                <div className="col-sm one">
                    <div className="card main">
                        <div className="card-header d-flex align-items-center">
                            {translate.t("ClubList")}
                            <button className="btn btn-primary btn-thiner ml-auto" onClick={() => openCloseModal(true, "")}>
                                {translate.t("Add")}
                            </button>
                            <button className="btn btn-danger btn-thiner ml-2" onClick={() => showDelNotifi()}>
                                {translate.t("DeleteSelected")}
                            </button>
                        </div>
                        <div className={`d-flex px-3 py-2 bg-light border-bottom align-items-center`}>
                            <div className="form-group mr-3">
                                <div className="text-nowrap fs12">{translate.t("Sport")}</div>
                                <select
                                    className="form-control form-control-sm"
                                    value={listVariables.filters.sportID}
                                    onChange={(e) => setListVariables({ ...listVariables, filters: { ...listVariables.filters, sportID: e.target.value } })}
                                >
                                    <option value={0}>-- {translate.t("Choose")} --</option>
                                    {clubListData?.sports.map((item, index) => (
                                        <option key={index} value={item.sportID}>
                                            {item.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group mr-3">
                                <div className="text-nowrap fs12">{translate.t("Country")}</div>
                                <select
                                    className="form-control form-control-sm"
                                    value={listVariables.filters.countryID}
                                    onChange={(e) => setListVariables({ ...listVariables, filters: { ...listVariables.filters, countryID: e.target.value } })}
                                >
                                    <option value={0}>-- {translate.t("Choose")} --</option>
                                    {clubListData?.allCountries.map((item, index) => (
                                        <option key={index} value={item.countryID}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <div className="text-nowrap fs12">{translate.t("Federation")}</div>
                                <select
                                    className="form-control form-control-sm"
                                    value={listVariables.filters.federationID}
                                    onChange={(e) =>
                                        setListVariables({ ...listVariables, filters: { ...listVariables.filters, federationID: e.target.value } })
                                    }
                                >
                                    <option value={0}>-- {translate.t("Choose")} --</option>
                                    {clubListData?.federations.map((item, index) => (
                                        <option key={index} value={item.federationID}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group ml-auto">
                                <div className="text-nowrap fs12">{translate.t("Search")}</div>
                                <SearchInput
                                    className={"form-control form-control-sm "}
                                    value={searchQuery}
                                    onChange={(text) => {
                                        setListVariables({ ...listVariables, filters: { ...listVariables.filters, searchQuery: text, offset: 0 } });
                                    }}
                                    textChanged={(text) => {
                                        setSearchQuery(text);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="card-body">
                            {!error ? (
                                <div>
                                    <div className="data-list">
                                        <div className="data-list-item header">
                                            <div className="data-list-item-content">
                                                <div style={{ flex: 1.5 }}>{translate.t("ClubTitle")}</div>
                                                <div style={{ flex: 1.5 }}>{translate.t("ClubEmail")}</div>
                                                <div>{translate.t("ClubCountry")}</div>
                                                <div>{translate.t("ClubFederation")}</div>
                                                <div>{translate.t("ClubSports")}</div>
                                                <div className="text-center">{translate.t("ShowOnWeb")}</div>
                                                <div className="text-right">{translate.t("Options")}</div>
                                            </div>
                                        </div>
                                        <Fragment>
                                            {clubListData?.clubs?.map((item, index) => {
                                                var checked = false;
                                                for (let i in selectedClubs) {
                                                    if (selectedClubs[i] == item.clubID) checked = true;
                                                }

                                                return (
                                                    <div key={index} className="data-list-item-content">
                                                        <div style={{ flex: 1.5 }}>{item.name}</div>
                                                        <div style={{ flex: 1.5, wordBreak: "break-all" }}>{item.email}</div>
                                                        <div>{item?.country?.name}</div>
                                                        <div>{item?.federation?.name}</div>
                                                        <div>
                                                            {item?.sports?.map((item, index) => (
                                                                <div>{item.title}</div>
                                                            ))}
                                                        </div>
                                                        <div className="text-center">{item.showOnWeb == "1" ? translate.t("Yes") : translate.t("No")}</div>
                                                        <div className="text-right">
                                                            <img onClick={() => openCloseModal(true, item.clubID)} className="edit-icon" src={edit} />
                                                            <input
                                                                className="delete-checked"
                                                                type="checkbox"
                                                                name="deleteClub[]"
                                                                checked={checked}
                                                                onChange={(e) => initiateDeleteClub(e, item.clubID)}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </Fragment>
                                    </div>
                                    {!loading ? (
                                        <Fragment>
                                            {!loading && (
                                                <>
                                                    {!!clubListData?.clubs?.length ? (
                                                        <>
                                                            {clubListData.clubs.length < clubListData.clubsCount && (
                                                                <div className="text-center p-5">
                                                                    <button
                                                                        className="btn btn-primary"
                                                                        onClick={() =>
                                                                            fetchMore({
                                                                                variables: {
                                                                                    ...listVariables,
                                                                                    filters: {
                                                                                        ...listVariables.filters,
                                                                                        offset: clubListData.clubs.length,
                                                                                    },
                                                                                },
                                                                                updateQuery: (prev, { fetchMoreResult }) => {
                                                                                    if (!fetchMoreResult) return prev;
                                                                                    return Object.assign({}, prev, {
                                                                                        clubs: [...prev.clubs, ...fetchMoreResult.clubs],
                                                                                    });
                                                                                },
                                                                            })
                                                                        }
                                                                    >
                                                                        {" "}
                                                                        {translate.t("LoadMore")}{" "}
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <NoItems text={translate.t("NoItemsAddedYet")} />
                                                    )}
                                                </>
                                            )}
                                        </Fragment>
                                    ) : (
                                        <Loading />
                                    )}
                                </div>
                            ) : (
                                <Fragment>{error && <Error text={error} />}</Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showAdd && (
                <AddEditClub
                    openCloseModal={openCloseModal}
                    selectedClubID={selectedClubID}
                    listVariables={listVariables}
                    updated={() =>
                        refetch({
                            filters: {
                                ...listVariables.filters,
                                limit: listVariables.filters.limit > clubListData.clubs.length ? listVariables.filters.limit : clubListData.clubs.length,
                            },
                        })
                    }
                />
            )}
            {showDeleteNotifi && <ModalNotification yesNo={true} text={translate.t("RemoveItems?")} callback={delClub} />}
        </div>
    );
};

export default Clubs;
